<ng-container *ngIf="!useAlternate; else staticBackup">
  <canvas class="animation-canvas" riv="constellation-reflect" [height]="canvasHeight" [width]="canvasWidth">
    <riv-player name="ReflectBuildIn" mode="one-shot" [play]="playIntro" (playChange)="playChange()"></riv-player>
    <riv-player name="ReflectLoop" [play]="playLoop"></riv-player>
  </canvas>
</ng-container>

<ng-template #staticBackup>
  <img class="logo-img" src="assets/images/purposeful-guide.png" alt="Image of a diamond enclosed by a circle" />
</ng-template>
